import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import Training from "./pages/Training";
import Contact from "./pages/Contact";

const GlobalContainer = styled.div`
    font-family: "FuturaPT-Demi", sans-serif;
    background: var(--brand-black);
    min-height: 100vh;
`;

const WhatsAppFab = styled.a`
    position: fixed;
    right: 2rem;
    bottom: 2rem;
    z-index: 30;
    width: 3.75rem;
    height: 3.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background: var(--brand-surface);
    color: #25d366;
    border: 1px solid var(--brand-gold);
    transition: transform 0.25s ease, background 0.25s ease;

    &:hover {
        transform: translateY(-2px);
        background: var(--brand-black);
    }
`;

const App = () => {
    return (
        <GlobalContainer>
            <WhatsAppFab
                href="https://api.whatsapp.com/send?phone=60166880996"
                target="_blank"
                rel="noreferrer"
                aria-label="Chat on WhatsApp"
            >
                <FaWhatsapp size={32} />
            </WhatsAppFab>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route exact path="/about">
                        <About />
                    </Route>
                    <Route exact path="/team">
                        <Team />
                    </Route>
                    <Route exact path="/contact">
                        <Contact />
                    </Route>
                    <Route exact path="/training">
                        <Training />
                    </Route>
                </Switch>
                <ToastContainer
                    style={{ width: "fit-content", overflow: "hidden" }}
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Router>
        </GlobalContainer>
    );
};

export default App;
